export default {
  1: '中文',
  2: '日语',
  3: '韩语',
  4: '英语',
  5: '俄语',
  6: '越南语',
  7: '繁体',
  8: '泰语',
  9: '印尼语'
};
